import { render } from "./ProviderGrid.vue?vue&type=template&id=6deb2152&scoped=true&ts=true"
import script from "./ProviderGrid.vue?vue&type=script&lang=ts"
export * from "./ProviderGrid.vue?vue&type=script&lang=ts"

import "./ProviderGrid.vue?vue&type=style&index=0&id=6deb2152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deb2152"]])

export default __exports__